<template>
  <div>
    <div :class="{ 'summar-box-2': isUi2 }">
      <div class="card-margin">
        <h2 class="demo-price-block demo-price-text">
          Order Total:
          <span class="primary" style="text-align: right; margin-right: 10px"
            >{{ order.TotalEstmCost | numberFormat }} + Tax</span
          >
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    isUi2: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
  },
};
</script>
<style scoped lang="scss">
.box-h {
  color: $color-white;
}

.check-o {
  color: $color-primary;
}

.item {
  margin-bottom: 8px;
}

.title {
  display: flex;
  justify-content: space-between;
}

.title-edit {
  margin-left: 16px;
}
.demo-block {
  border: 1px solid #ebebeb;
  border-radius: 5px;
  transition: 0.2s;
  width: 500px;
  margin-bottom: 10px;
  margin: 10px auto;
}
.list-name-container {
  margin-top: 16px;
  margin-left: 10px;
  font-weight: bold;
}
.demo-price-block {
  margin-top: 16px;
  margin-left: 16px;
}

.demo-price-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
  font-size: 1rem;
  color: #616161;
}
.demo-box {
  margin-left: 8px;
  margin-bottom: 0px;
  margin-top: 8px;
}
.card-margin {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MOrderTotal.vue